import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  template: '<navigation-toolbar class="public" />',
  styleUrl: './styles/common-public-styles.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PublicComponent {}
